/* Copyright (C) 2020 Soil Capital Belgium SPRL - All Rights Reserved */
const lockStatuses = {
  NOT_LOCKER: 0,
  UNLOCKED: 1,
  LOCKED: 2,
};

export default lockStatuses;
